import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const FolderGroup = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M21 17.5v-10c0-.827-.673-1.5-1.5-1.5H12a.406.406 0 0 1-.276-.17l-.553-1.106c-.207-.414-.71-.725-1.171-.725H3c-.461 0-.965.311-1.171.725l-.553 1.105A3.022 3.022 0 0 0 1 7v10.5c0 .827.673 1.5 1.5 1.5h17c.827 0 1.5-.673 1.5-1.5zm-19 .001v-10.5c0-.197.083-.548.171-.724l.553-1.106A.404.404 0 0 1 3 5.001h7c.085 0 .238.093.276.17l.553 1.106c.206.413.71.724 1.171.724h7.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5z" />
    <path d="M22 7v10.874A2.127 2.127 0 0 1 19.873 20H3s0 1 1 1h15.873C21.6 21 23 19.6 23 17.874V7.998C23 6.999 22 7 22 7z" />{' '}
  </SvgIcon>
);

export default FolderGroup;
